import axiosInstance from "../axiosInstance";
import APIPaths from "../../utils/APIPaths";
import { toast } from "react-toastify";

export const saveHospitalization = async (data) => {
  try {
    const URL = `${APIPaths.ADD_HOSPITALIZATION_RECORD}`;
    const res = await axiosInstance.post(URL, data);
    if (res && res?.status === 201) {
      toast.success(res?.data?.message);
      return res?.data?.data;
    }
  } catch (err) {
    toast.error(err?.response?.data?.message);
  }
};

export const updateHospitalization = async (data) => {
  try {
    const URL = `${APIPaths.UPDATE_HOSPITALIZATION_RECORD}`;
    const res = await axiosInstance.post(URL, data);
    if (res && res?.status === 200) {
      toast.success(res?.data?.message);
      return res?.data?.data;
    }
  } catch (err) {
    toast.error(err?.response?.data?.message);
  }
};

export const addHospitalizationRoomDetails = async (data) => {
  try {
    const URL = `${APIPaths.ADD_HOSPITALIZATION_ROOM}`;
    const res = await axiosInstance.post(URL, data);
    if (res && res?.status === 200) {
      toast.success(res?.data?.message);
      return res?.data?.data;
    }
  } catch (err) {
    const message =
      err?.response?.data?.data?.message ||
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong.";

    toast.error(message);
  }
};

export const deleteHospitalizationRecord = async (id) => {
  try {
    const URL = `${APIPaths.DELETE_HOSPITALIZATION_RECORD_BY_ID}${id}`;
    const response = await axiosInstance.delete(URL);
    if (response && response?.status === 200) {
      toast.success(response?.data?.data?.message);
      return response;
    }
  } catch (err) {
    toast.error(err?.response?.data?.data?.message);
  }
};

export const getHospitalizationListForClient = async (
  clientId,
  pageNo,
  rowsPerPage
) => {
  try {
    const URL = `${APIPaths.GET_HOSPITALIZATION_LIST_BY_CLIENT_ID}${clientId}/${pageNo}/${rowsPerPage}`;
    const res = await axiosInstance.get(URL);
    if (res && res?.status === 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error(err?.response?.data?.data?.message);
  }
};

export const getHospitalizationList = async (page, rowsPerPage, data) => {
  try {
    const URL = `${APIPaths.GET_ALL_HOSPITALIZATION_BY_ORG}${page}/${rowsPerPage}`;
    const res = await axiosInstance.get(URL, {
      params: {
        filter: data,
      },
    });
    if (res && res?.status === 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error(err?.response?.data?.data?.message);
  }
};

export const saveCheckUpDetails = async (data) => {
  try {
    const URL = `${APIPaths.ADD_CHECK_UP_RECORD}`;
    const res = await axiosInstance.post(URL, data);
    if (res && res?.status === 200) {
      toast.success(res?.data?.message);
      return res?.data?.data;
    }
  } catch (err) {
    if (err.response.data.errors) {
      for (const item in err.response.data.errors) {
        toast.error(err.response.data.errors[item]);
      }
    } else if (err.response?.data?.message) {
      toast.error(err?.response?.data?.message);
    } else {
      toast.error(err?.response?.data?.data?.message);
    }
  }
};

export const updateCheckUpDetails = async (data, id) => {
  try {
    const URL = `${APIPaths.UPDATE_CHECK_UP_RECORD}/${id}`;
    const res = await axiosInstance.put(URL, data);
    if (res && res?.status === 200) {
      toast.success(res?.data?.message);
      return res?.data?.data;
    }
  } catch (err) {
    if (err.response.data.errors) {
      for (const item in err.response.data.errors) {
        toast.error(err.response.data.errors[item]);
      }
    } else if (err.response?.data?.message) {
      toast.error(err?.response?.data?.message);
    } else {
      toast.error(err?.response?.data?.data?.message);
    }
  }
};

export const getAllCheckUpDataByHospitalizationId = async (
  id,
  pageNo,
  rowsPerPage
) => {
  try {
    const URL = `${APIPaths.GET_ALL_CHECK_UP_RECORD_BY_HOSPITALIZATION}${id}/${pageNo}/${rowsPerPage}`;
    const res = await axiosInstance.get(URL);
    if (res && res?.status === 200) {
      return res?.data;
    }
  } catch (err) {
    toast.error(err?.response?.data?.data?.message);
  }
};

export const getAllRoomDataByHospitalizationId = async (
  id,
  pageNo,
  rowsPerPage
) => {
  try {
    const URL = `${APIPaths.GET_ALL_ROOMS_BY_HOSPITALIZATION}${id}/${pageNo}/${rowsPerPage}`;
    const res = await axiosInstance.get(URL);
    if (res && res?.status === 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error(err?.response?.data?.data?.message);
  }
};

export const changeHospitalizationRoom = async (data) => {
  try {
    const URL = `${APIPaths.HOSPITALIZATION_ROOM_CHANGE}`;
    const res = await axiosInstance.post(URL, data);
    if (res && res?.status === 200) {
      toast.success(res?.data?.message);
      return res?.data?.data;
    }
  } catch (err) {
    const message =
      err?.response?.data?.data?.message ||
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong.";

    toast.error(message);
  }
};

export const updateStatus = async (id, status, reason, finalDiagnosis) => {
  try {
    const URL = `${APIPaths.MODIFY_HOSPITALIZATION_STATUS}${id}`;

    const response = await axiosInstance.patch(URL, null, {
      params: { status, reason, finalDiagnosis },
    });
    if (response?.status === 200) {
      toast.success(response?.data?.message);
      return response?.data?.data;
    }
  } catch (err) {
    toast.error(err?.response?.data?.data?.message);
  }
};

export const addInsuranceDetails = async (data) => {
  try {
    const URL = `${APIPaths.ADD_INSURANCE}`;
    const res = await axiosInstance.post(URL, data);
    if (res && res?.status === 201) {
      toast.success(res?.data?.message);
      return res?.data?.data;
    }
  } catch (err) {
    if (err?.response?.data?.errors) {
      for (const item in err?.response?.data?.errors) {
        toast.error(err?.response?.data?.errors[item]);
      }
    } else {
      toast.error(err?.response?.data?.message);
    }
  }
};

export const updateInsuranceDetails = async (id, data) => {
  try {
    const URL = `${APIPaths.UPDATE_INSURANCE}${id}`;
    const res = await axiosInstance.put(URL, data);
    if (res && res?.status === 200) {
      toast.success(res?.data?.message);
      return res?.data?.data;
    }
  } catch (err) {
    if (err?.response?.data?.errors) {
      for (const item in err?.response?.data?.errors) {
        toast.error(err?.response?.data?.errors[item]);
      }
    } else {
      toast.error(err?.response?.data?.message);
    }
  }
};

export const getHospitalizationRecord = async (id) => {
  try {
    const URL = `${APIPaths.GET_HOSPITALIZATION_RECORD_BY_ID}${id}`;
    const response = await axiosInstance.get(URL);
    if (response && response?.status === 200) {
      toast.success(response?.data?.data?.message);
      return response;
    }
  } catch (err) {
    toast.error(err?.response?.data?.data?.message);
  }
};

export const getPrescriptionByPrescriptionId = async (id) => {
  try {
    const URL = APIPaths.GET_PRESCRIPTION_BY_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {
    toast.error(error?.response?.data?.data?.message);
  }
};

export const getInsuranceDetailsById = async (id) => {
  try {
    const URL = APIPaths.GET_INSURANCE_BY_ID + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {
    toast.error(error?.response?.data?.data?.message);
  }
};

export const getAllInsuranceDetailsById = async (id) => {
  try {
    const URL = APIPaths.GET_ALL_INSURANCE_BY_HOSPITALIZATION + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {
    toast.error(error?.response?.data?.data?.message);
  }
};

export const updateInsuranceStatus = async (id, status) => {
  try {
    const URL = `${APIPaths.CHANGE_INSURANCE_STATUS}`;

    const response = await axiosInstance.patch(URL, null, {
      params: { id, status },
    });

    if (response?.status === 200) {
      toast.success(response?.data?.message);
      return response?.data?.data;
    }
  } catch (err) {
    if (err?.response?.status === 400) {
      toast.error(err?.response?.data?.message);
    } else {
      toast.error(err?.response?.data?.data?.message);
    }
  }
};

export const getHospitalizationRoomBillItems = async (id) => {
  try {
    const URL = APIPaths.GET_HOSPITALIZATION_ROOM_BILL_ITEMS + id;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {
    toast.error(error?.response?.data?.data?.message);
  }
};

export const getTypesOfRoomList = async () => {
  try {
    const URL = APIPaths.GET_ALL_HOSPITALIZATION_ROOM_TYPE;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {
    toast.error(error?.response?.data?.data?.message);
  }
};

export const updateRoomDetails = async (data) => {
  try {
    const URL = `${APIPaths.UPDATE_HOSPITALIZATION_ROOM}`;
    const res = await axiosInstance.post(URL, data);
    if (res && res?.status === 200) {
      toast.success(res?.data?.message);
      return res?.data?.data;
    }
  } catch (err) {
    toast.error(err?.response?.data?.message);
  }
};

export const getHospitalizationListForConsultant = async (
  pageNo,
  rowsPerPage,
  consultantId
) => {
  try {
    const URL = `${APIPaths.GET_ALL_HOSPITALIZATION_BY_CONSULTANT}/${pageNo}/${rowsPerPage}`;
    const res = await axiosInstance.get(URL, {
      params: {
        consultantId: consultantId,
      },
    });
    if (res && res?.status === 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error(err?.response?.data?.data?.message);
  }
};

export const deleteInsuranceRecord = async (id) => {
  try {
    const URL = `${APIPaths.DELETE_INSURANCE}${id}`;
    const response = await axiosInstance.delete(URL);
    if (response && response?.status === 200) {
      toast.success(response?.data?.data?.message);
      return response;
    }
  } catch (err) {
    toast.error(err?.response?.data?.data?.message);
  }
};

export const getHospitalizationCheckUpBillItems = async (id) => {
  try {
    const URL = APIPaths.GET_ALL_CHECKUP_BILL_ITEMS + id;
    const response = await axiosInstance.get(URL);

    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {
    toast.error(error?.response?.data?.data?.message);
  }
};

export const finishHospitalizationCheckUp = async (checkUpId) => {
  return axiosInstance
    .put(APIPaths.FINISH_HOSPITALIZATION_CHECK_UP + checkUpId)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else if (response.data.includes("Error:")) {
        toast.error(response.data);
        return {
          status: 400,
          data: response,
        };
      } else {
        toast.error(response);
        return response;
      }
    })
    .catch((error) => {
      if (error.response?.status === 409) {
        return error.response;
      }
      if (error.response.data.errors) {
        for (const item in error.response.data.errors) {
          toast.error(error.response.data.errors[item]);
        }
      } else {
        toast.error(error.response.data);
      }
    });
};
